import { Button, Stack, Text, TextInput } from "@mantine/core";
import { FC, useState } from "react";
import { isEmail, useForm } from "@mantine/form";

import { useTranslation } from "react-i18next";
import { passwordRecovery } from "../../api/userApi";

interface Props {
  onContinue: () => void;
}

export const ForgotPasswordForm: FC<Props> = ({ onContinue }) => {
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const form = useForm({
    initialValues: {
      email: "",
    },
    validate: {
      email: isEmail(t("forgot_password.validation_email_error")),
    },
  });

  const handleSubmit = async (values: typeof form.values) => {
    setLoading(true);
    try {
      await passwordRecovery(values.email);
      onContinue();
      setLoading(false);
    } catch (error) {
      setError(t("couldnt_find_account"));
      setLoading(false);
      console.log(error);
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Stack align="stretch" justify="center" gap="24px">
        <TextInput
          placeholder={t("forgot_password.email_placeholder")}
          label={t("forgot_password.email_label")}
          {...form.getInputProps("email")}
        />
        {error && (
          <>
            <Text color="red" size="sm">
              {error}
            </Text>
          </>
        )}
        <Button fullWidth type="submit" loading={loading}>
          {t("forgot_password.continue_button")}
        </Button>
      </Stack>
    </form>
  );
};
